const bodyTag = document.querySelector('body');

if (bodyTag.classList.contains('template-product')) {

    //Tabs on product page
    const tabsBtn = document.querySelectorAll('.tabs__nav-btn');
    const tabsItems = document.querySelectorAll('.tabs__item');

    tabsBtn.forEach(onTabClick);

    function onTabClick(item) {
        item.addEventListener('click', function() {
            let currentBtn = item;
            let tabId = currentBtn.getAttribute('data-tab');
            let currentTab = document.querySelector(tabId);

            if( ! currentBtn.classList.contains('active') ) {
                tabsBtn.forEach(function(item) {
                    item.classList.remove('active');
                });
        
                tabsItems.forEach(function(item) {
                    item.classList.remove('active');
                });
        
                currentBtn.classList.add('active');
                currentTab.classList.add('active');
            }
        });
    }

    document.querySelector('.tabs__nav-btn').click();

    //Correct product-details-wrapper height
    document.addEventListener('DOMContentLoaded', () => {
        let checkHeight = document.querySelector('.check-height'),
            assignHeight = document.querySelector('.assign-height');

        function giveHeight() {
            assignHeight.style.minHeight = checkHeight.clientHeight + 'px';
        }

        if (window.innerWidth > 1200) {
            giveHeight(); 
        } 
        
        window.addEventListener('resize', ()=> {
            if (window.innerWidth > 1200) {
                giveHeight(); 
            } else {
                assignHeight.style.minHeight = 'unset';
            }
        });
    });
}

